import axios from "axios";
import { expireSession } from "./session";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "/mock",
});

// Some production gateways (Cloudflare / WAF / strict Nginx) reject the CORS
// preflight for PATCH/PUT/DELETE. Tunnel them as POST + X-HTTP-Method-Override,
// which Symfony's Request reads natively to recover the original verb. The
// Laravel route resolver still matches PATCH/PUT/DELETE routes. No-op on GET/POST.
const METHOD_OVERRIDE = new Set(["patch", "put", "delete"]);

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (METHOD_OVERRIDE.has(method)) {
    config.headers["X-HTTP-Method-Override"] = method.toUpperCase();
    config.method = "post";
  }

  const jwt = localStorage.getItem("jwt");
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      expireSession();
    }
    return Promise.reject(error);
  }
);

export default api;
